import React from "react";
import Form from "../../../HelperComponents/Form/Form";
import { FormField } from "../../../HelperComponents/Form/FormTypes";

type AddEditEducationHistoryProps = {
  isOpen: boolean;
  onDismiss: () => void;
  mode?: "save" | "update";
  educationHistory?: any;
  itemId?: number | any;
};

const AddEditEducationHistory = (props: AddEditEducationHistoryProps) => {
  const parseCityState = (addr?: string) => {
    if (!addr) return { city: undefined, state: undefined };
    const parts = String(addr).split(",");
    const city = parts[0]?.trim() || undefined;
    const state = parts[1]?.trim() || undefined;
    return { city, state };
  };

  const parsed =
    props.mode === "update"
      ? parseCityState(props.educationHistory?.WorkAddress)
      : { city: undefined, state: undefined };
  const fields: FormField[] = [
    {
      id: "School",
      type: "Text",
      title: "School",
      placeholder: "School name",
      visible: true,
      value: props.mode === "update" ? props.educationHistory?.School : "",
      destinations: [{ destination: "educationHistory", fieldName: "School" }],
    },
    {
      id: "UserDegree",
      type: "Text",
      title: "Degree",
      placeholder: "Degree",
      visible: true,
      value: props.mode === "update" ? props.educationHistory?.UserDegree : "",
      destinations: [
        { destination: "educationHistory", fieldName: "UserDegree" },
      ],
    },
    {
      id: "City",
      type: "Text",
      title: "City",
      placeholder: "City",
      visible: true,
      value:
        props.mode === "update"
          ? (props.educationHistory?.City ?? parsed.city)
          : "",
      destinations: [
        { destination: "educationHistory", fieldName: "WorkAddress" },
      ],
    },
    {
      id: "State",
      type: "List",
      title: "State",
      placeholder: "Select state",
      visible: true,
      listName: "State",
      dropdownText: ["Code"],
      value:
        props.mode === "update"
          ? (props.educationHistory?.State ?? parsed.state)
          : "",
      destinations: [
        { destination: "educationHistory", fieldName: "WorkAddress" },
      ],
    },
    {
      id: "AttendedMonth",
      type: "List",
      title: "Attended Month",
      placeholder: "Select month",
      visible: true,
      options: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      value:
        props.mode === "update" ? props.educationHistory?.AttendedMonth : "",
      destinations: [
        { destination: "educationHistory", fieldName: "AttendedMonth" },
      ],
    },
    {
      id: "AttendedYear",
      type: "Text",
      title: "Attended Year",
      placeholder: "e.g., 2020",
      visible: true,
      maxlength: 4,
      value:
        props.mode === "update" ? props.educationHistory?.AttendedYear : "",
      destinations: [
        { destination: "educationHistory", fieldName: "AttendedYear" },
      ],
    },
    {
      id: "UntilMonth",
      type: "List",
      title: "Until Month",
      placeholder: "Select month",
      visible: true,
      options: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      value: props.mode === "update" ? props.educationHistory?.UntilMonth : "",
      destinations: [
        { destination: "educationHistory", fieldName: "UntilMonth" },
      ],
    },
    {
      id: "UntilYear",
      type: "Text",
      title: "Until Year",
      placeholder: "e.g., 2023",
      visible: true,
      maxlength: 4,
      value: props.mode === "update" ? props.educationHistory?.UntilYear : "",
      destinations: [
        { destination: "educationHistory", fieldName: "UntilYear" },
      ],
    },
    {
      id: "Graduated",
      type: "Checkbox",
      title: "Graduated",
      visible: true,
      value:
        props.mode === "update" ? props.educationHistory?.Graduated : false,
      destinations: [
        { destination: "educationHistory", fieldName: "Graduated" },
      ],
    },
  ];

  return (
    <>
      {props.isOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            backdropFilter: "blur(10px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          role="dialog"
          aria-modal="true"
        >
          <div
            style={{
              backgroundColor: "hsl(var(--background))",
              borderRadius: 8,
              boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
              maxWidth: "1100px",
              width: "90%",
              maxHeight: "90vh",
              overflowY: "auto",
              padding: "16px 24px 24px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 16,
              }}
            >
              <h2 style={{ margin: 0, color: "hsl(var(--primary))" }}>
                {props.mode === "update" ? "Edit Education" : "Add Education"}
              </h2>
              <button
                type="button"
                onClick={props.onDismiss}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontSize: 20,
                  lineHeight: 1,
                  color: "hsl(var(--foreground))",
                }}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <Form
              fields={fields}
              columns={3}
              mode={props.mode ?? "save"}
              itemId={
                props?.itemId ??
                props.educationHistory?.ID ??
                props.educationHistory?.Id
              }
              onCancel={props.onDismiss}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AddEditEducationHistory;
